import { SKIP_AMOUNT_SUGGESTION_KEY } from './constants';

export const getPaymentResultUrl = urlParams => {
	if (urlParams) {
		const queryString = Object.keys(urlParams)
			.map(key => `${key}=${urlParams[key]}`)
			.join('&');
		return `/payment/result/deposit?${queryString}`;
	}
};

export const skipAmountSuggestion = () => window.sessionStorage.getItem(SKIP_AMOUNT_SUGGESTION_KEY) === 'true';
